import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import { style } from "variables/Variables.jsx";
import "../../assets/css/react-confirm-alert/react-confirm-alert.css";
import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";
import { BeatLoader } from "react-spinners";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { css } from "@emotion/core";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { List } from "react-virtualized";
import { isApiResponse, isReportAccess, user_activities,reactSelectStyles,date_range_config } from '../../helpers/utils.js';

import Dropzone from "react-dropzone";
import Switch from "react-switch";
// import "../campaign_module.css";
import qr_image from "assets/img/default_qr_image.png";
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config("1", "1", "2020-02-01", "1");
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
class AddCamplaint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      datefrom: date_config.start_date,
      dateTo: date_config.end_date,
      datefromShow: date_config.display_start_date,
      dateToShow: date_config.display_end_date,
      yestSend: date_config.start_date_value,
      todSend: date_config.end_date_value,
      dateFromLimit: date_config.start_date_limit,
      dateLimit: date_config.end_date_limit,
      ticket_number: "",
      case_number: "",
      sender: "",
      start_date: moment(new Date()).format("YYYY-MM-DD"),
      end_date: moment(new Date()).format("YYYY-MM-DD"),
      notice_details: "",
      disputed_details: "",
      customer_details: "",
      merchant_details:"",
      action_taken: "",
      pending_items: "",
      further_actions: "",
      additional_notes: ""
    };
  }
  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: <div>{msg}</div>,
      level: level,
      position: position,
      autoDismiss: 5,
    });
  };
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var _notificationSystem = this.refs.notificationSystem;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    this.setState({ email: decoded.email });
    const tokenPermission = localStorage.userPermission;
    const decoded_permission = jwt_decode(tokenPermission);
    let AllAccessPermissions = decoded_permission.accessPermissions;
    isReportAccess(AllAccessPermissions, "crisp_add_new_complaint");

  }


  onChangeInput(e) {
    this.setState({ [e.target.name]: e.target.value });
    //         if(e.target.name==='utm_term' || e.target.name=='utm_content')
    //         {
    //             this.setState({
    //                 is_qr_generated:false,
    //                 is_download_disabled:true
    //             })
    //         }
  }

  create_complaint() {

    if (this.state.ticket_number == "") {
      this.handleNotificationClick("tr", 3, "Please Enter  Ticket Number");
      return false;
    }
    if (this.state.case_number == "") {
      this.handleNotificationClick("tr", 3, "Please Enter Case Number");
      return false;
    }
    if (this.state.sender == "") {
      this.handleNotificationClick("tr", 3, "Please Enter Sender");
      return false;
    }

    var data = {
        date_of_receipt: this.state.start_date,
        ticket_number: this.state.ticket_number,
        case_number: this.state.case_number,
        sender: this.state.sender,
        notice_details: this.state.notice_details,
        disputed_details: this.state.disputed_details,
        customer_details: this.state.customer_details,
        merchant_details: this.state.merchant_details,
        action_taken: this.state.action_taken,
        pending_items: this.state.pending_items,
        further_actions: this.state.further_actions,
        additional_notes: this.state.additional_notes,
        email: this.state.email
    };

    axios
      .post(
        config.get("API_URL") + "/CrispReport/create_new_complaint/",
        data,
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => { console.log(response.data)
        if (response.data.status=='error') {
          this.handleNotificationClick("tr", 3, response.data.message);
        } else {
          this.handleNotificationClick(
            "tr",
            1,
            response.data.message
          );
          this.reset_all();
          setTimeout(
            function () {
              this.redirect_to_list();
            }.bind(this),
            2000
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  redirect_to_list(e) {
    const { history } = this.props;
    history.push("/admin/police-complaint-report");
  }
  reset_all(e) {
    this.setState({
      datefrom: date_config.start_date,
      dateTo: date_config.end_date,
      datefromShow: date_config.display_start_date,
      dateToShow: date_config.display_end_date,
      yestSend: date_config.start_date_value,
      todSend: date_config.end_date_value,
      dateFromLimit: date_config.start_date_limit,
      dateLimit: date_config.end_date_limit,
      ticket_number: "",
      case_number: "",
      sender: "",
      start_date: moment(new Date()).format("YYYY-MM-DD"),
      end_date: moment(new Date()).format("YYYY-MM-DD"),
      notice_details: "",
      disputed_details: "",
      customer_details: "",
      merchant_details:"",
      action_taken: "",
      pending_items: "",
      further_actions: "",
      additional_notes: ""

    });
    setTimeout(
      function () {
        this.componentDidMount();
      }.bind(this),
      200
    );
  }
  handleFromChange = (date) => {
    var start_date1 = moment(date).format("YYYY-MM-DD");
    //alert(start_date1);
    this.setState({
      start_date: start_date1,
    });
  };

  handleToChange = (date) => {
    var end_date2 = moment(date).format("YYYY-MM-DD");
    //alert(end_date2);
    this.setState({
      end_date: end_date2,
    });
  };
  onRedirectTypeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      is_qr_generated: false,
    });
  };
  render() {

    const MenuList = (props) => {
      const rows = props.children;
      let no_of_rows = 0;
      let drop_down_heigth = 0;
      if (rows.length !== undefined) {
        no_of_rows = rows.length;
        if (no_of_rows < 9) {
          drop_down_heigth = 40 * no_of_rows;
        } else {
          drop_down_heigth = 300;
        }
      }
      const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
        <div key={key} style={style}>
          {rows[index]}
        </div>
      );

      return (
        <List
          style={{ width: "100%" }}
          width={300}
          height={drop_down_heigth}
          rowHeight={30}
          rowCount={no_of_rows}
          rowRenderer={rowRenderer}
        />
      );
    };
    const customStyles = {
      control: (provided) => ({
        ...provided,
        padding: "0px",
        minHeight: "32px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "35px",
      }),
      clearIndicator: (provided) => ({
        ...provided,
        padding: "5px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "5px",
      }),
      valueContainer: (base) => ({
        ...base,
        padding: "0px 6px",
      }),
      menu: (styles) => ({ ...styles, zIndex: 999 }),
    };
    return (
      <div className="content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 pt-5">
              <div className="">
                <div className="content">
                  <div className="row">
                    <div className="col-xs-12 padd-5">
                      <div className="card title-card-bottom-space">
                        <div className="header">
                          <h4 className="title">Create New Complaint</h4>
                          <p className="category"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="content">
                  <div className="row">
                    <div className="col-lg-12 padd-5">
                      <div className="card add-camp-con">
                        <div className="content">
                          <div className="row">
                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label> Date of Receipt </label>
                                    <DatePicker
                                    dateFormat="d MMM yyyy"
                                    selected={Date.parse(this.state.start_date)}
                                    onChange={this.handleFromChange}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label> Ticket No. </label>
                                  <Input
                                    id="ticket_number"
                                    name="ticket_number"
                                    value={this.state.ticket_number}
                                    onChange={this.onChangeInput.bind(this)}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label> Sender</label>
                                  <Input
                                    id="sender"
                                    name="sender"
                                    value={this.state.sender}
                                    onChange={this.onChangeInput.bind(this)}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="clearfix"></div>
                            </div>
                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Case Number </label>
                                  <textarea
                                    name="case_number"
                                    rows="4"
                                    placeholder=""
                                    id="case_number"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.case_number}
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Notice details</label>
                                  <textarea
                                    name="notice_details"
                                    rows="4"
                                    placeholder=""
                                    id="notice_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.notice_details}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Disputed Details</label>
                                  <textarea
                                    name="disputed_details"
                                    rows="4"
                                    id="disputed_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.disputed_details}
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="clearfix"></div>
                            </div>
                            <div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Customer Details</label>
                                  <textarea
                                    name="customer_details"
                                    rows="4"
                                    id="customer_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.customer_details}
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Merchant Details</label>
                                  <textarea
                                    name="merchant_details"
                                    rows="4"
                                    id="merchant_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.merchant_details}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Action Taken</label>
                                  <textarea
                                    name="action_taken"
                                    rows="4"
                                    id="action_taken"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.action_taken}
                                  ></textarea>
                                </div>
                              </div>


                              <div className="clearfix"></div>
                            </div>
                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Pending Items</label>
                                  <textarea
                                    name="pending_items"
                                    rows="4"
                                    id="pending_items"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.pending_items}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Further Actions</label>
                                  <textarea
                                    name="further_actions"
                                    rows="4"
                                    id="further_actions"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.further_actions}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Additional Notes</label>
                                  <textarea
                                    name="additional_notes"
                                    rows="4"
                                    id="additional_notes"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.additional_notes}
                                  ></textarea>
                                </div>
                              </div>

                              <div className="clearfix"></div>
                            </div>


                            <div>
                              <div className="col-md-3">
                                <label>&nbsp;</label>
                                <div>
                                  <button
                                    className="campaignButton"
                                    role="button"
                                    onClick={this.create_complaint.bind(this)}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                              <div className="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCamplaint;
